export default __webpack_public_path__ + "static/Cashflow 101+202-2a58d0c499865e4b2ec3a4298eeec353.jpg";